<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/plan/delicious'">
      <ZuiHeader />
      <SubPageTemplate page-title="吃得巴适" dynamically-tab :pid="pid" :default-tab-id="tabId" :isShowTab="false" :page-size="6" type="article" :video-mask="false" @article-click="articleClick">
      </SubPageTemplate>
      <ZuiFooter />
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
/** @format */

import SubPageTemplate from '~/components/template/SubPageTemplate.vue';

export default {
    components: {
        SubPageTemplate,
    },
    data() {
        return {
            pid: null,
            tabId: '',
        };
    },
    created() {
        this.tabId = this.$route.query.id || null;
        this.pid = this.$cid.play.chiDeBaShi;
        if (this.$route.path == '/plan/delicious') {
            let obj = {
                pid: this.pid,
                tabId: this.tabId,
            };
            sessionStorage.setItem('deliciousParams', JSON.stringify(obj));
        }
    },
    watch: {
        $route(val, old) {
            console.log(val);
            if (this.$route.path == '/plan/delicious') {
                if ((!this.$route.query.id || !this.$route.query.id) && sessionStorage.getItem('deliciousParams')) {
                    let obj = JSON.parse(sessionStorage.getItem('deliciousParams'));
                    console.log(obj);
                    this.pid = obj.pid;
                    this.tabId = obj.tabId;
                }
            }
        },
    },
    methods: {
        articleClick(item) {
            this.$openNewWindow('/new/plan/delicious/info?id=' + item.id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/plan/delicious.vue